
import { defineComponent, ref, reactive } from 'vue';
import { getDeviceList } from '@/api/community/device';
import removeFunc from '@/methods/remove-func';
import List from '@/components/common/list/src/list.vue';
import { ListActionItem } from '@/components/common/list';
import { overlayFormData } from '@/util/system';
import { deleteDevice } from '@/api/common/device';
import DeviceStatus from '@/components/view/common/device-status/index.vue';

export default defineComponent({
    components: {
        List,
        DeviceStatus
    },
    props: {
        type: {
            type: String,
            default: 'project'
        },
        deviceType: {
            type: String,
            default: 'control'
        }
    },
    setup() {
        // searchKey选择项
        const searchKeyList = [{
            label: WordList.TabelPersonDeviceInHtmlMAC,
            name: 'MAC'
        }, {
            label: WordList.MulListUpdateListTanleAccount,
            name: 'SipAccount'
        }, {
            label: WordList.ProperAllCommunity,
            name: 'Project'
        }, {
            label: WordList.NavInHtmlCommunity,
            name: 'Installer'
        }];

        const updateData = ref(0);

        // 搜索条件
        const formData = reactive({
            searchKey: 'MAC',
            searchValue: '',
            Brand: 'all',
            row: 10,
            page: 1
        });
        overlayFormData(formData);

        // 表头   迁移name 改成prop,增加 {
        //     name: 'op',
        //         label: WordList.CaptureListTanleAction
        // }
        const column = [{
            name: 'MAC',
            label: WordList.TabelPersonDeviceInHtmlMAC
        }, {
            name: 'Project',
            label: WordList.ProperAllCommunity
        }, {
            name: 'Installer',
            label: WordList.NavInHtmlCommunity
        }, {
            name: 'Status',
            label: WordList.MulListUpdateListTanleStatus,
            type: 'customize'
        }, {
            name: 'SipAccount',
            label: WordList.MulListUpdateListTanleAccount
        }, {
            name: 'LastConnected',
            label: WordList.PersonaldeviceListTanleBindingTime
        }];

        // 表格数据获取
        const tableData = reactive<{row: object[];detail: object[];total: string}>({
            row: [],
            detail: [],
            total: '0'
        });

        // 获取第三方设备数据
        const getThirdPartyDeviceApi = () => {
            getDeviceList(formData, (res: {row: object[];detail: object[];total: string}) => {
                tableData.row = res.row;
                tableData.detail = res.detail;
                tableData.total = res.total;
                updateData.value += 1;
            });
        };
        getThirdPartyDeviceApi();

        // 删除
        const deleteThirdPartyDeviceApi = (data: { ID: string }) => {
            removeFunc(WordList.TabelDeleteText, () => {
                deleteDevice({ ID: data.ID }, getThirdPartyDeviceApi);
            });
        };

        // action操作 迁移备注：这部分不用迁移 主要是为了适配删除触发点击
        const action: ListActionItem[] = [{
            type: 'delete2',
            event(data: { ID: string }) {
                deleteThirdPartyDeviceApi(data);
            },
            class: 'el-icon-delete delete-icon',
            title: WordList.TabelConfigInHtmlDelete
        }];

        return {
            formData,
            searchKeyList,
            column,
            getThirdPartyDeviceApi,
            tableData,
            deleteThirdPartyDeviceApi,
            action,
            updateData
        };
    }
});
